export default "__VITE_ASSET__vdL7GHCx__"